import { Campaign } from "../share/campaigns/store";

export const orderCampaigns = (campaigns: Campaign[]) => {
  const _campaigns = [...campaigns];
  _campaigns.sort(function (a, b) {
    // Note: Some demo campaigns and draft campaigns have a null publishedAt date
    // TODO: Create different types of Campaign interfaces:
    // DraftCampaign --> publishedAt: null
    // PublishedCampaign --> publishedAt: Date
    if (a.publishedAt === null && b.publishedAt === null) return 0;
    if (a.publishedAt === null) return 1;
    if (b.publishedAt === null) return -1;

    let t1 = new Date(a.publishedAt).getTime();
    let t2 = new Date(b.publishedAt).getTime();

    return t2 - t1;
  });

  return _campaigns;
};
